angular.module("Main").directive("footerShop", footerShop);

function footerShop() {
    return {
        templateUrl: "./app/Main/controls/footer/footerShop.html",
        restrict: "EA",
        controller: FooterController,
        controllerAs: "vm",
        scope: false
    };
}

FooterController.$inject = ["$rootScope", "$scope", "$location", "$state", "$uibModal", "$translate", "tmhDynamicLocale", "$localStorage", "LANGUAGES", "SessionService", "DialogService", "BookingService"];

function FooterController($rootScope, $scope, $location, $state, $uibModal, $translate, tmhDynamicLocale, $localStorage, LANGUAGES, SessionService, DialogService, BookingService) {
    var vm = this;

    vm.languageList = LANGUAGES;


    vm.openPrivacyTerms = function () {
        $uibModal.open({
            templateUrl: "app/Main/views/dialogs/agbOnlineSales.html",
            controller: "OnlineSalesPrivacyTermsDialogController",
            controllerAs: "vm"
        });
    };
}